<template>
  <el-container class="page-x" direction="vertical">
    <div class="search-x">
      <div class="search-item">
        <span class="label">label_1</span>
        <el-input
          class="input-box"
          clearable
          v-model.trim="searchBox.s_prop_1"
        ></el-input>
      </div>
      <div class="search-item">
        <span class="label">label_2</span>
        <el-input
          class="input-box"
          clearable
          v-model.trim="searchBox.s_prop_2"
        ></el-input>
      </div>
      <div class="search-item">
        <span class="label">label_3</span>
        <el-input
          class="input-box"
          clearable
          v-model.trim="searchBox.s_prop_3"
        ></el-input>
      </div>
      <div class="search-item">
        <span class="label">label_4</span>
        <el-select v-model="searchBox.s_prop_4" class="input-box" clearable>
          <el-option
            v-for="item in s_option_1"
            :value="item.id"
            :key="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <span class="label">label_5</span>
        <el-date-picker
          v-model="timeRange"
          type="daterange"
          @change="toChangeTime"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="timestamp"
        >
        </el-date-picker>
      </div>
      <!--添加权限码-->
      <!--v-auth="'sw_operate_log_index'"-->
      <el-button type="primary" @click="toSearch">查询</el-button>
      <el-button type="plain" @click="toAddOrEditOrView(1, null)"
        >新增</el-button
      >
    </div>
    <div class="cont-x">
      <div class="table-x" ref="tableBox">
        <el-table v-loading="loading" :data="tableData" border class="mb20">
          <el-table-column type="index" align="center" label="序号" width="100">
          </el-table-column>
          <el-table-column prop="table_1" align="center" label="属性一">
          </el-table-column>
          <el-table-column prop="table_2" align="center" label="属性二">
          </el-table-column>
          <el-table-column prop="table_3" align="center" label="属性三">
          </el-table-column>
          <el-table-column align="center" label="属性三">
            <template slot-scope="scope">
              {{ num2Text(scope.row.table_4, "s_option_1") }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="属性三">
            <template slot-scope="scope">
              {{ num2Text(scope.row.f_prop_2, "f_option_1") }}
            </template>
          </el-table-column>
          <el-table-column prop="table_6" align="center" label="属性三">
          </el-table-column>
          <el-table-column align="center" label="操作时间">
            <template slot-scope="scope">
              {{ scope.row.createTime | dateFormat("Y-m-d H:i:s") }}
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="240"
            align="center"
          >
            <template slot-scope="scope">
              <el-button-group>
                <el-button
                  size="middle"
                  class="mb10"
                  type="text"
                  @click="toAddOrEditOrView(2, scope.row)"
                  >编辑
                </el-button>
                <el-button
                  size="middle"
                  class="mb10"
                  type="text"
                  @click="toUpOrDown(1, scope.row)"
                  >启用
                </el-button>
                <el-button
                  size="middle"
                  class="mb10"
                  type="text"
                  @click="toUpOrDown(2, scope.row)"
                  >禁用
                </el-button>
                <el-button
                  size="middle"
                  class="mb10"
                  type="text"
                  @click="toAddOrEditOrView(3, scope.row)"
                  >查看</el-button
                >
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagenation-x">
      <div class="pagination mb20">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchBox.pageNum"
          :page-size="searchBox.pageSize"
          layout="total,  prev, pager, next, jumper"
          :total="total"
          background
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新增、修改弹层 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      center
      width="40%"
      @close="toCloseDialog"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="formRules"
        label-width="80px"
        style="width: 80%"
      >
        <el-form-item label="f_label_1" prop="f_prop_1">
          <el-input
            v-model="form.f_prop_1"
            :disabled="formType === 3"
          ></el-input>
        </el-form-item>
        <el-form-item label="f_label_2" prop="f_prop_2">
          <el-select
            v-model="form.f_prop_2"
            placeholder="请选择状态"
            :disabled="formType === 3"
          >
            <el-option
              v-for="(item, index) in f_option_1"
              :key="index"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="f_label_3" prop="f_prop_3">
          <el-input
            v-model="form.f_prop_3"
            :disabled="formType === 3"
          ></el-input>
        </el-form-item>
        <el-form-item label="f_label_4" prop="f_prop_4">
          <el-input
            v-model="form.f_prop_4"
            :disabled="formType === 3"
          ></el-input>
        </el-form-item>
        <el-form-item label="f_label_5">
          <el-input
            v-model="form.f_prop_5"
            :disabled="formType === 3"
          ></el-input>
        </el-form-item>
        <el-form-item label="f_label_6" prop="f_prop_6">
          <el-radio-group v-model="form.f_prop_6" :disabled="formType === 3">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="toSaveForm">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>
<script>
// 注意事项（注意demo页面的注释文字）
// 1. 页面上的data中的属性根据后端接口进行全局替换
// 2. 按钮权限
// 3. 页面table字段中的过滤器
// 4. form表单的校验文案替换
// 5. get, post（JSON提交），post(formData提交)
// 6. created 定义导航屑
// 7. form表单 新增、修改、查看 的细微区别
const _options_1 = [
  { label: "待预约", id: 1 },
  { label: "预约中", id: 2 },
  { label: "待体检", id: 3 },
  { label: "已到检", id: 4 },
  { label: "待出报告", id: 5 },
];
const _tableData = [
  {
    table_1: "11111",
    table_2: "22222",
    table_3: "33333",
    table_4: 4,
    f_prop_2: 2,
    table_6: "666",
    table_7: "7",
  },
];
const _f_option_1 = [
  { label: "启用", id: 1 },
  { label: "禁用", id: 2 },
];
import { isArray } from "@/assets/js/until.js";
export default {
  data() {
    return {
      loading: false,
      // 查询条件
      timeRange: [],
      searchBox: {
        pageSize: 10,
        pageNum: 1,
        s_prop_1: "",
        s_prop_2: "",
        s_prop_3: "",
        s_prop_4: "",
        s_prop_5: "", // 开始日期
        s_prop_6: "", // 结束日期
      },
      s_option_1: _options_1,
      tableData: _tableData,
      total: 0,
      dialogTitle: "", // 弹窗title
      dialogFormVisible: false, // 弹窗是否展示
      formType: 1, // 弹窗类型 1-新增 2-编辑 3-查看
      form: {
        id: "", // 主键
        f_prop_1: "",
        f_prop_2: "",
        f_prop_3: "",
        f_prop_4: "",
        f_prop_5: "",
        f_prop_6: 1,
      },
      f_option_1: _f_option_1,
      // trigger  input框--值为blur, select框值为change
      formRules: {
        f_prop_1: [{ required: true, message: "请填写", trigger: "blur" }],
        f_prop_2: [{ required: true, message: "请填写", trigger: "blur" }],
        f_prop_3: [{ required: true, message: "请填写", trigger: "blur" }],
        f_prop_4: [{ required: true, message: "请填写", trigger: "blur" }],
      },
    };
  },
  created() {
    // 面包导航
    this.$root.breadList = [
      { name: "一级菜单", link: "" },
      { name: "二级菜单", link: "" },
      { name: "三级菜单", link: "" },
    ];
  },
  mounted() {},
  methods: {
    get() {
      // apiName 的维护路径为 config/api.js 中的apiCore对象
      let apiName = "xxx";
      let data = {};
      this.axios
        .get(this.getApiUrl(apiName), {
          params: data,
        })
        .then((res) => {
          let { status, msg, data } = res;
          if (status === 200) {
            console.log(data);
          } else {
            this.$message.warning(msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    post() {
      let apiName = "xxxx";
      let data = {};
      this.axios
        .post(this.getApiUrl(apiName), data)
        .then((res) => {
          let { status, msg, data } = res;
          if (status === 200) {
            console.log(data);
          } else {
            this.$message.warning(msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    toChangeTime(val) {
      console.log(val, "时间");
      if (val) {
        this.searchBox.s_prop_5 = val[0];
        this.searchBox.s_prop_6 = val[1];
      } else {
        this.searchBox.s_prop_5 = "";
        this.searchBox.s_prop_6 = "";
      }
    },
    num2Text(id, keyName) {
      if (this[keyName] && isArray(this[keyName])) {
        let findItem = this[keyName].find((o) => o.id === id);
        return findItem["label"];
      } else {
        return id;
      }
    },
    toUpOrDown(type, item) {
      let txt = type === 1 ? "启用" : "禁用";
      this.$confirm(`此操作将${txt}该选中项, 是否继续?`, "提示", {
        type: "warning",
      })
        .then(() => {
          window.alert(JSON.stringify(item));
          this.$message({
            type: "success",
            message: `${txt}成功!`,
          });
        })
        .catch(() => {
          window.alert(JSON.stringify(item));
          this.$message({
            type: "info",
            message: `已取消${txt}`,
          });
        });
    },
    // 关闭弹窗，重置rule
    toCloseDialog() {
      // 这两句话的顺序不能调换，不然会有错误，上一表单数据会出现回光返照的现象
      this.$refs.form.resetFields();
      this.resetForm();
    },
    toSaveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          window.alert(JSON.stringify(this.form));
          // 调用提交接口
          this.toPostData();
        } else {
          return false;
        }
      });
    },
    toPostData() {
      // 新增时，删除主键id
      if (this.formType === 1) {
        delete this.form.id;
      }
    },
    toAddOrEditOrView(type, item) {
      this.resetForm();
      this.formType = type;
      this.dialogTitle = type === 1 ? "新增" : type === 2 ? "修改" : "编辑";
      this.dialogFormVisible = true;
      if (item) {
        this.setForm(item);
      }
    },
    // 重置表单
    resetForm() {
      for (let key in this.form) {
        this.form[key] = "";
      }
      // 对于某些需要初始化的字段，可以在这里单独重置，例如单选按钮默认选中的值
      this.form.f_prop_6 = 1;
    },
    // 赋值表单
    setForm(data) {
      let keys = Object.keys(this.form);
      keys.forEach((key) => {
        this.form[key] = data[key];
      });
    },
    toSearch() {
      this.searchBox.pageSize = 1;
      window.alert(JSON.stringify(this.searchBox));
      this.getData();
    },
    getData() {},
    handleSizeChange(val) {
      this.searchBox.pageNum = 1;
      this.searchBox.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.searchBox.pageNum = val;
      this.getData();
    },
  },
};
</script>
<style type="text/scss" lang="scss" scoped>
.search-x {
  min-height: 120px;
  flex-shrink: 0;
}
.cont-x {
  flex: 1;
  flex-shrink: 0;
}
</style>
